import React from 'react';
import PropTypes from 'prop-types';
import { DtpTitle } from 'dtp-react-components';

const Title = props => (
  <DtpTitle title={props.title} type={props.type} fontWeight={props.fontWeight} />
);

Title.propTypes = {
  /** String contendo o texto a ser exibido no título */
  title: PropTypes.string.isRequired,
  /** Atributo que define o tipo do título */
  type: PropTypes.oneOf(['page', 'section']),
  /** Espessura da fonte do título */
  fontWeight: PropTypes.oneOf([
    'light-34',
    'light-48',
    'light-56',
    'light-72',
    'light-120',
    'semibold-12',
    'semibold-14',
    'semibold-15',
    'semibold-18',
    'semibold-20',
    'semibold-42',
    'regular-10',
    'regular-12',
    'regular-16',
    'regular-28',
  ]),
};

Title.defaultProps = {
  type: 'page',
  fontWeight: 'regular-16',
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Title.jsx